import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const BccToggleButtonGroup = withStyles({})((props: any) => (
  <ToggleButtonGroup {...props} />
))

export default BccToggleButtonGroup
